// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"c0d61063","575":"107c813e","664":"236251d6","670":"9212e7a6","755":"99756b84"}[chunkId] + ".chunk.js";
};